/**
 * Singleton browser Supabase client.
 *
 * Mirrors FluidGhost's web/src/lib/supabase.ts and FluidTalk's
 * app/lib/supabase.ts: same project, same cookie domain, same SDK major. Built
 * with @supabase/ssr's createBrowserClient and a cookie scoped to COOKIE_DOMAIN
 * so the session is SHARED across the ecosystem's subdomains.
 *
 * Memoized: exactly ONE GoTrueClient per tab. Multiple instances race each other
 * refreshing the same token.
 */
import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY, COOKIE_DOMAIN, AUTH_CONFIGURED } from './env';

let client: SupabaseClient | null | undefined;

/** The shared browser client, or null when auth isn't configured. */
export function getSupabase(): SupabaseClient | null {
  if (client !== undefined) return client;
  if (!AUTH_CONFIGURED) {
    client = null;
    return client;
  }
  client = createBrowserClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    ...(COOKIE_DOMAIN ? { cookieOptions: { domain: COOKIE_DOMAIN } } : {}),
  });
  return client;
}
